/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetServerStatus: BridgeCommands.Command<
    {},
    Types.Common.Gamestream.GetServerStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gamestream',
    method: 'GetServerStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetServerStatus: BridgeCommands.Command<
    Types.Common.Gamestream.SetServerStatusParameters,
    Types.Common.Gamestream.SetServerStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gamestream',
    method: 'SetServerStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetPairedDevices: BridgeCommands.Command<
    {},
    Types.Common.Gamestream.GetPairedDevicesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gamestream',
    method: 'GetPairedDevices',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RemovePairedDevices: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gamestream',
    method: 'RemovePairedDevices',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterPairedDeviceNotification: BridgeCommands.Command<
    {},
    Types.Common.Gamestream.RegisterPairedDeviceNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gamestream',
    method: 'RegisterPairedDeviceNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterShieldDeviceNotification: BridgeCommands.Command<
    {},
    Types.Common.Gamestream.RegisterShieldDeviceNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gamestream',
    method: 'RegisterShieldDeviceNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RespondToUpdateNotification: BridgeCommands.Command<
    Types.Common.Gamestream.RespondToUpdateNotificationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gamestream',
    method: 'RespondToUpdateNotification',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAppsList: BridgeCommands.Command<
    {},
    Types.Common.Gamestream.GetAppsListReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gamestream',
    method: 'GetAppsList',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const AddAppCollectorItem: BridgeCommands.Command<
    Types.Common.Gamestream.AddAppCollectorItemParameters,
    Types.Common.Gamestream.AppInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gamestream',
    method: 'AddAppCollectorItem',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RemoveAppCollectorItem: BridgeCommands.Command<
    Types.Common.Gamestream.RemoveAppCollectorItemParameters,
    Types.Common.Gamestream.RemoveAppCollectorItemReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gamestream',
    method: 'RemoveAppCollectorItem',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EditAppCollectorItem: BridgeCommands.Command<
    Types.Common.Gamestream.EditAppCollectorItemParameters,
    Types.Common.Gamestream.AppInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Gamestream',
    method: 'EditAppCollectorItem',
    persistent: false
};

export const Gamestream = {
GetServerStatus,
SetServerStatus,
GetPairedDevices,
RemovePairedDevices,
RegisterPairedDeviceNotification,
RegisterShieldDeviceNotification,
RespondToUpdateNotification,
GetAppsList,
AddAppCollectorItem,
RemoveAppCollectorItem,
EditAppCollectorItem
};
